import { request } from '@blade/common';
// 添加人体库
export function addBodyLibrary(data) {
    return request({
        method: 'POST',
        data,
        url: '/api/portrait-management/api/v1/bodylib/add',
    });
}
// 更新人体库
export function updateBodyLibrary(data) {
    return request({
        method: 'PUT',
        data,
        url: `/api/portrait-management/api/v1/bodylib/${data.libId}`,
    });
}
// 查询人体库列表
export function queryBodyLibPageList(data) {
    return request({
        method: 'POST',
        data,
        url: `/api/portrait-management/api/v1/bodylib/page/query`,
    });
}
// 查询人体列表
export function queryBodyPageList(data) {
    return request({
        method: 'POST',
        data,
        url: `/api/portrait-management/api/v1/portraitbody/page/query`,
    });
}
export function enableBodyLib(libId) {
    return request({
        method: 'PUT',
        url: `/api/portrait-management/api/v1/bodylib/enable/${libId}`,
    });
}
export function disableBodyLib(libId) {
    return request({
        method: 'PUT',
        url: `/api/portrait-management/api/v1/bodylib/disable/${libId}`,
    });
}
export function deleteBodyLib(libId) {
    return request({
        method: 'DELETE',
        url: `/api/portrait-management/api/v1/bodylib/${libId}`,
    });
}
export function batchDeleteBodys(data) {
    return request({
        url: '/api/portrait-management/api/v1/portraitbody/batch/delete',
        method: 'POST',
        data,
    });
}
export function bodyExport(data) {
    return request({
        url: '/api/portrait-management/api/v1/portraitbody/export',
        method: 'POST',
        data,
    });
}
export function addBody(data) {
    return request({
        url: '/api/portrait-management/api/v1/portraitbody/add',
        method: 'POST',
        data,
    });
}
export function queryBodyDetail(portraitBodyId) {
    return request({
        url: `/api/portrait-management/api/v1/portraitbody/${portraitBodyId}`,
        method: 'GET',
    });
}
export function updateBody(data) {
    return request({
        url: `/api/portrait-management/api/v1/portraitbody/update/${data.portraitBodyId}`,
        method: 'PUT',
        data,
    });
}
export function deleteBodyRelation(data) {
    return request({
        url: '/api/portrait-management/api/v1/portraitbody/delete',
        method: 'DELETE',
        data,
    });
}
